import IVeiculosRepository from '../repositories/IVeiculosRepository'

export interface IGetImagemVeiculo {
  execute(id: number): Promise<string>
}

export default class GetImagemVeiculoImpl implements IGetImagemVeiculo {
  constructor(private readonly veiculoRepository: IVeiculosRepository) {}

  public async execute(id: number): Promise<string> {
    return await this.veiculoRepository.getImagemVeiculo(id)
  }
}
